import { useFormik } from "formik";
import { useTranslation } from "react-i18next";
import { useAxios } from "hooks";
import { FullHeight } from "components";
import MetadataSearchForm from "./components/MetadataSearchForm";
import MetadataResult from "./components/MetadataResult";
import initialValuesMetadata from "./components/initialValuesMetadata";
import { useSelector } from "react-redux";

const TelemetryMetadata = () => {
    const { t } = useTranslation("telemetry");

    // TODO: Change type any after redo auth
    const { user: { client: { clnt } } } = useSelector((state: any) => state.user);

    // Define search form handler
    const [post, { data: searchResult, loading: loadingSave }] = useAxios({
        method: "post",
        url: "/api/vvr/monitor/metadata",
    });

    // Init Formik
    const formik = useFormik({
        initialValues: initialValuesMetadata,
        enableReinitialize: true,
        onSubmit: values => {
            post(values); // Call search
        },
        onReset: values => {

        }
    });

    const { values } = formik;

    return (
        <FullHeight>
            <MetadataSearchForm
                formik={formik}
                loadingSave={loadingSave}
            />
            {searchResult &&
                <MetadataResult
                    data={searchResult}
                />
            }
        </FullHeight>

    );
};

export default TelemetryMetadata;